// import axios from 'axios';
// import { endPoint } from '../Endpoints/endpoint';

// const defaultHeaders = {
//   // 'Accept': 'application/json',
//   'Content-Type': 'application/json',
//   apiKey: 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e',
// };

// let headersForm = {
//   'Content-Type': 'multipart/form-data',
// };

// class ApiService {
//   constructor() {
//     this.axiosInstance = axios.create({
//       // baseURL: "http://qfinityinventoryapi.softaxusdemo.com",
//       baseURL: 'https://procapi.apps.pro360erp.com',
//       headers: defaultHeaders,
//     });

//     this.axiosInstance.interceptors.request.use(this.requestInterceptor);

//     this.axiosInstance.interceptors.response.use(this.responseInterceptor, this.errorInterceptor);
//   }

//   requestInterceptor = (config) => {
//     const token = this.getToken();
//     if (token) {
//       config.headers['Authorization'] = `Bearer ${token}`;
//     }

//     return config;
//   };

//   responseInterceptor = (response) => {
//     return response;
//   };

//   errorInterceptor = async (error) => {
//     if (error.response && error.response.status === 401) {
//       const token = this.getToken();
//       if (token) {
//         await this.handleRefreshToken();
//         const newToken = this.getToken();
//         if (newToken) {
//           error.config.headers['Authorization'] = `Bearer ${newToken}`;
//           return axios.request(error.config);
//         } else {
//           console.error('Token refresh failed');
//           return Promise.reject(error);
//         }
//       } else if (this.isLoginOrSignupRequest(error.config)) {
//         return axios.request(error.config);
//       } else {
//         console.error('User not authenticated');
//         return Promise.reject(new Error('Unauthorized'));
//       }
//     } else {
//       return Promise.reject(error);
//     }
//   };

//   isLoginOrSignupRequest(config) {
//     const url = config.url;
//     return url.includes('USER_LOGIN') || url.includes('USER_SIGNUP');
//   }

//   async handleRefreshToken() {
//     try {
//       const response = await this.axiosInstance.post(endPoint['REFRESH_TOKEN'], {
//         token: this.getToken(),
//         refreshToken: this.getRefreshToken(),
//       });

//       if (response.status === 200) {
//         this.setToken(response.data.result.token);
//       }
//     } catch (error) {
//       console.error('Token refresh failed', error);
//     }
//   }

//   getToken() {
//     return localStorage.getItem('Token');
//   }

//   setToken(token) {
//     localStorage.setItem('Token', token);
//   }

//   getRefreshToken() {
//     return localStorage.getItem('RefreshToken');
//   }

//   setRefreshToken(refreshToken) {
//     localStorage.setItem('RefreshToken', refreshToken);
//   }

//   async get(path) {
//     return this.axiosInstance.get(endPoint[path]);
//   }
//   async getApiParamater(path, data) {
//     return this.axiosInstance.get(endPoint[path] + data);
//   }
//   async post(path, data) {
//     return this.axiosInstance.post(endPoint[path], data);
//   }
//   async postMultiPart(path, body) {
//     let res = false;
//     await axios
//       .post(endPoint[path], body, headersForm)
//       .then((response) => {
//         res = response;
//       })
//       .catch((err) => {
//         res = err?.response?.data?.message;
//       });
//     return res;
//   }
//   async putMultiPart(path, body) {
//     let res = false;
//     await axios
//       .put(endPoint[path], body, headersForm)
//       .then((response) => {
//         res = response;
//       })
//       .catch((err) => {
//         res = err?.response?.data?.message;
//       });
//     return res;
//   }
//   async put(path, data) {
//     return this.axiosInstance.put(endPoint[path], data);
//   }
//   async delete(path, data) {
//     return this.axiosInstance.delete(endPoint[path], data);
//   }
//   async deleteParameter(path, data) {
//     return this.axiosInstance.delete(endPoint[path] + data);
//   }
// }

// export default ApiService;

import axios from 'axios';
import { endPoint } from '../Endpoints/endpoint';

// ======== CONFIG ========
const BASE_URL = 'https://procapi.apps.pro360erp.com';
// Which DB field to send in the 'DB' header:
const DB_FIELD = 'dataDB'; // or 'baseDB'
const COMPANY_SLICE_CANDIDATES = ['companies', 'userCompanies', 'auth'];

const defaultHeaders = {
  'Content-Type': 'application/json',
  apiKey: 'V+kBloEwqqVhoEwqqVho1PINmQI0VJQwSBX2l/e' // keep yours as-is
    .replace('EwqqVho1PINmQI0VJQwSBX2l/e', 'Vho1PINmQI0VJQwSBX2l/e'), // safeguard if pasted twice
};
defaultHeaders.apiKey = 'V+kBloEwqqVho1PINmQI0VJQwSBX2l/e';

const multipartHeaders = {
  'Content-Type': 'multipart/form-data',
  apiKey: defaultHeaders.apiKey,
};

// ======== Helpers: resolve active company DB from localStorage ========
function readCompanies() {
  const direct = localStorage.getItem('userCompanies');
  if (direct) {
    try {
      const parsed = JSON.parse(direct);
      if (Array.isArray(parsed)) return parsed;
    } catch {}
  }
  const pr = localStorage.getItem('persist:root');
  if (pr) {
    try {
      const root = JSON.parse(pr);
      for (const k of COMPANY_SLICE_CANDIDATES) {
        if (root[k]) {
          const slice = JSON.parse(root[k]); // redux-persist slices are strings
          if (Array.isArray(slice)) return slice;
          if (Array.isArray(slice?.list)) return slice.list;
          if (Array.isArray(slice?.items)) return slice.items;
          if (Array.isArray(slice?.value)) return slice.value;
          if (slice?.company) return [slice.company];
        }
      }
    } catch {}
  }
  return null;
}
function getSelectedCompanyNo() {
  const v = localStorage.getItem('selectedCompanyNo');
  return v ? Number(v) : null;
}
function getActiveCompany() {
  const companies = readCompanies();
  if (!companies || companies.length === 0) return null;
  const sel = getSelectedCompanyNo();
  if (sel) {
    const match = companies.find((c) => Number(c.companyNo) === sel);
    if (match) return match;
  }
  return companies[0];
}
function getActiveCompanyDb() {
  const c = getActiveCompany();
  return c ? c[DB_FIELD] ?? null : null;
}
function getActiveBranchId() {
  // You store BranchId in localStorage from AppRoutes (GET_EMPLOYEE)
  return localStorage.getItem('BranchId');
}

// ======== Service ========
class ApiService {
  constructor() {
    this.axiosInstance = axios.create({
      baseURL: BASE_URL,
      headers: defaultHeaders,
    });

    // refresh guards
    this.isRefreshing = false;
    this.refreshWaiters = [];

    this.axiosInstance.interceptors.request.use(this.requestInterceptor);
    this.axiosInstance.interceptors.response.use(this.responseInterceptor, this.errorInterceptor);
  }

  // ===== Interceptors =====
  requestInterceptor = (config) => {
    const token = this.getToken();
    const companyDb = this.getCompany(); // resolved from active company object
    const branchId = getActiveBranchId(); // read from localStorage

    config.headers = config.headers || {};
    config.headers['apiKey'] = defaultHeaders.apiKey;

    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = defaultHeaders['Content-Type'];
    }
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (companyDb) {
      config.headers['DB'] = companyDb;
    }
    if (branchId) {
      // header names are case-insensitive; use lower camel for consistency
      config.headers['BranchId'] = String(branchId);
    }
    return config;
  };

  responseInterceptor = (response) => response;

  errorInterceptor = async (error) => {
    const original = error.config || {};
    if (error.response && error.response.status === 401 && !original._retried && !this.isLoginOrSignupRequest(original)) {
      // single-flight refresh
      if (this.isRefreshing) {
        const newToken = await new Promise((resolve) => this.refreshWaiters.push(resolve));
        if (newToken) {
          original.headers = original.headers || {};
          original.headers['Authorization'] = `Bearer ${newToken}`;
          const companyDb = this.getCompany();
          const branchId = getActiveBranchId();
          if (companyDb) original.headers['DB'] = companyDb;
          if (branchId) original.headers['branchId'] = String(branchId);
          original._retried = true;
          return this.axiosInstance.request(original);
        }
        return Promise.reject(error);
      }

      try {
        this.isRefreshing = true;
        const newToken = await this.handleRefreshToken(); // string|null
        // wake waiters
        this.refreshWaiters.forEach((w) => w(newToken));
        this.refreshWaiters = [];

        if (newToken) {
          original.headers = original.headers || {};
          original.headers['Authorization'] = `Bearer ${newToken}`;
          const companyDb = this.getCompany();
          const branchId = getActiveBranchId();
          if (companyDb) original.headers['DB'] = companyDb;
          if (branchId) original.headers['branchId'] = String(branchId);
          original._retried = true;
          return this.axiosInstance.request(original);
        }
      } catch (_) {
        // fall through
      } finally {
        this.isRefreshing = false;
      }
    }
    return Promise.reject(error);
  };

  // ================= HTTP METHODS =================
  get(path) {
    return this.axiosInstance.get(endPoint[path]);
  }

  getApiParamater(path, data) {
    return this.axiosInstance.get(endPoint[path] + data);
  }

  post(path, data) {
    return this.axiosInstance.post(endPoint[path], data);
  }

  put(path, data) {
    return this.axiosInstance.put(endPoint[path], data);
  }

  postMultiPart(path, body) {
    return this.axiosInstance.post(endPoint[path], body, { headers: multipartHeaders });
  }

  putMultiPart(path, body) {
    return this.axiosInstance.put(endPoint[path], body, { headers: multipartHeaders });
  }

  delete(path, params = {}) {
    return this.axiosInstance.delete(endPoint[path], { params });
  }

  deleteBody(path, body = {}) {
    return this.axiosInstance.delete(endPoint[path], {
      headers: { 'Content-Type': 'application/json' },
      data: body,
    });
  }

  deleteParam(path, id) {
    if (id === undefined || id === null) throw new Error("Missing required 'id' parameter for DELETE request");
    return this.axiosInstance.delete(`${endPoint[path]}+${id}`);
  }

  // ===== Auth & Tokens =====
  getToken() {
    return localStorage.getItem('Token');
  }
  setToken(token) {
    localStorage.setItem('Token', token);
  }
  getRefreshToken() {
    return localStorage.getItem('RefreshToken');
  }
  setRefreshToken(refreshToken) {
    localStorage.setItem('RefreshToken', refreshToken);
  }

  // Resolve DB from active company (NOT a static 'DataBase' key)
  getCompany() {
    return getActiveCompanyDb();
  }

  async handleRefreshToken() {
    try {
      const response = await this.axiosInstance.post(endPoint['REFRESH_TOKEN'], {
        token: this.getToken(),
        refreshToken: this.getRefreshToken(),
      });
      if (response.status === 200 && response.data?.result?.token) {
        const newToken = response.data.result.token;
        this.setToken(newToken);
        return newToken;
      }
    } catch (error) {
      console.error('Token refresh failed', error);
    }
    return null;
  }

  // mark auth endpoints as non-refreshable (skip retry loop)
  isLoginOrSignupRequest(config) {
    const url = (config.url || '').toString();
    return url.includes('USER_LOGIN') || url.includes('USER_SIGNUP') || url.includes(endPoint['USER_LOGIN']) || url.includes(endPoint['USER_SIGNUP']);
  }
}

export default ApiService;
